import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetRole } from "../../store/api/roleApi";

function RoleList({ onEdit }) {
  const getRole = useGetRole();
  const {
    data: roleData,
    isLoading: isRoleLoading,
    error: roleError,
  } = useQuery({ queryKey: "role", queryFn: getRole });

  const data = roleData?.role
    ?.map((role, index) => ({
      index: index + 1,
      name: role?.name,
      accessPoint: role?.accessPoint?.join(", "),
      actionButton: (
        <>
          <button
            onClick={() => onEdit(role)}
            className="btn text-success mx-2"
          >
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Access Point",
      accessor: "accessPoint",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isRoleLoading} />
    </div>
  );
}

export default RoleList;
